import SlimSelect from "slim-select";

export default class CustomSelect {
    private wrapper: HTMLElement;
    private selects: HTMLSelectElement[] | null;

    constructor(wrapper: HTMLElement) {
        this.wrapper = wrapper;
        this.selects = [...this.wrapper.querySelectorAll<HTMLSelectElement>("select")];

        this.init();
    }

    public init = async (): Promise<void> => {
        this.selects?.forEach((select) => {
            this.customSelect(select);
        });
    };

    private customSelect = (select) => {
        if (!select) return;

        new SlimSelect({
            select: select,
            settings: {
                showSearch: false,
            },
        });
    };
}
